import { createSlice } from "@reduxjs/toolkit";

import type { ApiRole } from "@/types/api/types.ts";

export type EnumContextState = {
  roles: ApiRole[];
};

const initialState: EnumContextState = {
  roles: [],
};

export const enumsSlice = createSlice({
  name: "enums",
  initialState,
  reducers: {
    setEnums: (state, action) => {
       
      return action.payload;
    },
    setRoles: (state, action) => {
      state.roles = action.payload;
    },
  },
});

export const { setEnums, setRoles } = enumsSlice.actions;

export default enumsSlice.reducer;
